module.exports = __webpack_public_path__ + "img/xichebang_logo.bda4c076.jpg";